// 引入 axios 库
import axios from "axios";
// import { Message } from "ant-design-vue";

//根据环境进行拼接路径
import config from "@/config";
let baseUrl = "";
if (process.env.NODE_ENV === "development") {
  //本地开发环境
  baseUrl = config.baseUrl.dev;
} else if (
  process.env.NODE_ENV !== "development" &&
  process.env.VUE_APP_USE == "内网"
) {
  //内网环境
  baseUrl = "https://ai.etoinfo.com";
} else {
  baseUrl = "https://ai.etoinfo.com";
}

axios.defaults.baseURL = baseUrl;

// 创建实例
const HttpRequest = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 300000, // 5分钟
});

// 请求拦截器
HttpRequest.interceptors.request.use(
  (configs) => {
    // configs.headers["Content-Type"] = "multipart/form-data";
    return configs;
  },
  (err) => {
    // 防御性编程, 处理可能出现的报错
    // Message.error(err.message);
    return Promise.reject(new Error(err.message));
  }
);

// 响应拦截器
HttpRequest.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log(error);
  }
);

export default HttpRequest;
